export const TEST_REPORT_ISSUERS = {
  "Bureau Veritas": `BUREAU VERITAS SHENZHEN CO., LTD.,
DONGGUAN BRANCH NO.34,
CHENWULU SECTION, GUANTAI RD.,
HOUJIE TOWN,
DONGGUAN CITY,
GUANGDONG PROVINCE, CHINA
523942
TEL: +86-769-89982098`,

  "Intertek Testing HK": `Intertek Testing Services Hong Kong Limited
2/F Garment Centre
576 Castle Peak Road
Kowloon, Hong Kong
Tel +852 2173 8888
Fax +852 2786 1903
intertek.com.hk`,
};
